import MembershipDetails from "../components/membershipUpgrade/details";

const MembershipUpgradeDetails = () => {
  return <MembershipDetails />;
};

export default MembershipUpgradeDetails;
